import React from 'react'
import PropTypes from 'prop-types'
import CustomScroll from 'react-custom-scroll'
import { Rtl } from '@/components/rtl'

let Scrollbar = (props) => <Rtl render={rtl => <CustomScroll allowOuterScroll rtl={rtl} {...props} />} />

Scrollbar.propTypes = {
  allowOuterScroll: PropTypes.bool,
  heightRelativeToParent: PropTypes.string,
  flex: PropTypes.number,
  onScroll: PropTypes.func,
  addScrolledClass: PropTypes.bool,
  freezePosition: PropTypes.bool,
  minScrollHandleHeight: PropTypes.number,
  rtl: PropTypes.bool,
  scrollTo: PropTypes.number,
  keepAtBottom: PropTypes.bool
}

export {
  Scrollbar
}



// WEBPACK FOOTER //
// ./src/components/scrollbar.js